import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/**
 * auth 模块 - 用户认证状态管理
 * state:
 *   - token: string，JWT Token，从 localStorage 恢复
 *   - user: object|null，当前用户信息，从 localStorage 恢复
 * mutations:
 *   - SET_TOKEN: 设置 token 并持久化到 localStorage
 *   - SET_USER: 设置用户信息并持久化到 localStorage
 *   - CLEAR: 清空 token 和用户信息，移除 localStorage
 * actions:
 *   - login: 登录，提交 SET_TOKEN 和 SET_USER
 *   - logout: 退出登录，提交 CLEAR
 *   - updateUser: 局部更新用户信息
 */
const authModule = {
  namespaced: true,
  state: {
    token: localStorage.getItem('token') || '', // 用户登录凭证
    user: JSON.parse(localStorage.getItem('user') || 'null') // 当前用户信息
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    CLEAR(state) {
      state.token = ''
      state.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
  },
  actions: {
    login({ commit }, data) {
      commit('SET_TOKEN', data.token)
      commit('SET_USER', data.user)
    },
    logout({ commit }) {
      commit('CLEAR')
    },
    updateUser({ commit, state }, user) {
      commit('SET_USER', { ...state.user, ...user })
    }
  }
}

/**
 * company 模块 - 公司切换状态管理
 * state:
 *   - currentCompany: object|null，当前选中的公司，从 localStorage 恢复
 *   - companies: Array，公司列表（运行时缓存）
 * mutations:
 *   - SET_CURRENT: 设置当前公司并持久化到 localStorage
 *   - SET_LIST: 设置公司列表
 * actions:
 *   - switchCompany: 切换公司并刷新页面
 */
const companyModule = {
  namespaced: true,
  state: {
    currentCompany: JSON.parse(localStorage.getItem('currentCompany') || 'null'), // 当前选中的公司
    companies: [] // 公司列表缓存
  },
  mutations: {
    SET_CURRENT(state, company) {
      state.currentCompany = company
      localStorage.setItem('currentCompany', JSON.stringify(company))
    },
    SET_LIST(state, companies) {
      state.companies = companies
    }
  },
  actions: {
    switchCompany({ commit }, company) {
      commit('SET_CURRENT', company)
      window.location.reload()
    }
  }
}

export default new Vuex.Store({
  modules: {
    auth: authModule,
    company: companyModule
  }
})
